<template>
  <div class="t-lk-modal__content">
    <h2 class="t-lk-modal__title">{{ props.title }}</h2>

    <form
      class="t-form t-filter__class t-lk-modal__form"
      :class="{ _disabled: infoForm.disabledForm }"
      @submit.stop.prevent="submitForm"
    >
      <div class="t-feedback__content t-lk-comp__form">
        <div v-for="(item, index) in cmpForm" class="t-feedback__item" :class="{ _radio: item.type === 'radio', _full: item.isFull }">
          <div v-if="item.title" class="t-form__label" :class="{ _radio: item.type === 'radio', _short: item.isShort }">
            {{ item.title }}
            <div v-if="item.tooltip" class="t-form-tooltip">
              <svg
                class="t-form-tooltip__svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9" r="6.5" stroke="#C0C0CC" />
                <path
                  d="M7.16602 7.20308C7.30712 6.80195 7.58564 6.4637 7.95224 6.24825C8.31884 6.03279 8.74987 5.95403 9.16897 6.02592C9.58808 6.09781 9.96822 6.3157 10.2421 6.64101C10.5159 6.96632 10.6658 7.37805 10.6652 7.80327C10.6652 9.00366 8.86457 9.60386 8.86457 9.60386"
                  stroke="#C0C0CC"
                  stroke-width="0.9"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.91211 12.0049H8.91811"
                  stroke="#C0C0CC"
                  stroke-width="0.9"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="t-form-tooltip__container" :class="{ _isBottom: item.tooltipBottom }">
                <div class="t-form-tooltip__content">
                  <div class="t-form-tooltip__top">{{ item.tooltip }}</div>
                  <div v-if="item.tooltipBottom" class="t-form-tooltip__bottom">
                    <svg
                      class="t-form-tooltip__svg-bottom"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.79097 14.6663C11.3765 14.6663 14.2831 11.6816 14.2831 7.99968C14.2831 4.31778 11.3765 1.33301 7.79097 1.33301C4.20546 1.33301 1.29883 4.31778 1.29883 7.99968C1.29883 11.6816 4.20546 14.6663 7.79097 14.6663Z"
                        stroke="#00b0bd"
                        stroke-width="1.12"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.79102 5.33333V8"
                        stroke="#00b0bd"
                        stroke-width="1.12"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.79102 10.667H7.79735"
                        stroke="#00b0bd"
                        stroke-width="1.12"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>{{ item.tooltipBottom }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <select-custom-cmp v-if="item.type === 'select'" :data="item" :ref="`select${item.id}`"> </select-custom-cmp>

          <input
            v-if="item.type === 'text' || item.type === 'number'"
            class="t-input"
            :class="{ _error: item.error, _valid: item.valid }"
            :type="item.type"
            :placeholder="item.hintField"
            v-model="item.value"
            @focus="focusForm(index)"
          />

          <div v-if="item.type === 'radio'" class="t-form__radio _gray">
            <template v-for="(radio, idxRadio) in item.list">
              <input
                :id="item.id.toString() + idxRadio"
                :name="item.id"
                class="t-radio"
                :value="radio.id"
                @change="changeRadio(index, $event)"
                :type="item.type"
                :ref="`radio${item.id}`"
              />

              <label :for="item.id.toString() + idxRadio" class="t-radio__text" :class="{ _error: item.error, _valid: item.valid }">
                {{ radio.label }}
              </label>
            </template>
          </div>

          <vue-dropzone
            v-if="item.type === 'radio' && item.value === '1' && item.dropzone"
            id="dropzone"
            class="_dynamic _reg _lk"
            :class="{ _error: item.error, _add: item.isFileAdd }"
            :ref="'dropzone' + item.id"
            :options="dropzoneOptions"
            :useCustomSlot="true"
            @vdropzone-file-added="fileAdded(item, index)"
            @vdropzone-removed-file="fileAdded(item, index)"
          >
            <div class="dropzone-custom-title">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.08 8.28768L9.18747 15.1802C8.34309 16.0246 7.19786 16.4989 6.00372 16.4989C4.80959 16.4989 3.66436 16.0246 2.81997 15.1802C1.97559 14.3358 1.50122 13.1906 1.50122 11.9964C1.50122 10.8023 1.97559 9.65707 2.81997 8.81268L9.71247 1.92018C10.2754 1.35726 11.0389 1.04102 11.835 1.04102C12.6311 1.04102 13.3946 1.35726 13.9575 1.92018C14.5204 2.48311 14.8366 3.24659 14.8366 4.04268C14.8366 4.83878 14.5204 5.60226 13.9575 6.16518L7.05747 13.0577C6.77601 13.3391 6.39427 13.4973 5.99622 13.4973C5.59818 13.4973 5.21643 13.3391 4.93497 13.0577C4.65351 12.7762 4.49539 12.3945 4.49539 11.9964C4.49539 11.5984 4.65351 11.2166 4.93497 10.9352L11.3025 4.57518"
                  stroke="#C0C0CC"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ $root.staticText.forms.placeholderDropzone2 }}
            </div>
          </vue-dropzone>
        </div>
      </div>

      <vue-recaptcha
        ref="recaptcha"
        size="invisible"
        :sitekey="$root.sitekeyRecaptcha"
        :load-recaptcha-script="true"
        @verify="onCapchaRegister"
        @expired="onCaptchaExpired"
        @error="errorCaptcha"
      />

      <div class="t-feedback__raw">
        <div class="t-personal-data t-personal-data__comp" :class="{ _error: infoForm.errorPersonalData }">
          <input @change="changePersonalDataFrom()" type="checkbox" :id="'personal-data-comp'" class="t-personal-data__input" />
          <label :for="'personal-data-comp'">
            <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z"
                fill="white"
              />
            </svg>
            <span>
              {{ $root.staticText.forms.agree }}
              <a href="/user-agreement" target="_blank" class="t-personal-data__link">
                {{ $root.staticText.forms.personalData }}
              </a>
            </span>
          </label>
        </div>
        <button class="t-btn _big t-feedback__btn _green">{{ props.button }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import selectCustom from '@components/ui-components/select-custom/select-custom.vue'
import vue2Dropzone from 'vue2-dropzone'
import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'request',
  props: ['props'],
  data() {
    return {
      recaptchaToken: null,
      isValid: false,
      vendorId: null,
      maskPattern: /^(\d){1,}/,
      infoForm: {
        action: 'lk/competenciesCallback',
        disabledForm: false,
        isPersonalData: false,
        errorPersonalData: false,
        success: false,
        error: false,
      },
      cmpForm: [],
      dropzoneOptions: {
        url: 'callback',
        autoQueue: false,
        thumbnailWidth: 80,
        thumbnailHeight: 80,
        maxFiles: 100, // максимальное количество файлов
        maxFilesize: 10, // максимальный вес одного файла, MB
        addRemoveLinks: true,
        dictRemoveFile: '×',
        acceptedFiles: '.jpg, .jpeg, .pdf, .png, .doc, .docx, .txt, .tif, .svg',
        dictFileTooBig: 'Файл слишком большой. Максимальный размер файла: {{maxFilesize}} MB.',
        dictInvalidFileType: 'Вы не можете загружать файлы этого типа.',
        dictMaxFilesExceeded: 'Вы не можете больше загружать файлы.',
      },
      formInfo: {
        fields: [
          {
            type: 'form_field',
            content: {
              id: 'salesVolume',
              title: this.$root.staticText.lk.compForm,
              typeField: 3,
              requiredField: 1,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip,
              tooltipBottom: '',
              hintField: this.$root.staticText.lk.compFormPlaceholder,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'currencyId',
              title: this.$root.staticText.lk.compForm8,
              typeField: 7,
              requiredField: 1,
              description: null,
              tooltip: '',
              tooltipBottom: '',
              hintField: this.$root.staticText.lk.compFormPlaceholder8,
              list: this.props.currencies,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'reviews',
              title: this.$root.staticText.lk.compForm2,
              typeField: 13,
              requiredField: 0,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip,
              tooltipBottom: '',
              hintField: this.$root.staticText.lk.compFormPlaceholder2,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'marketing',
              title: this.$root.staticText.lk.compForm6,
              typeField: 14,
              requiredField: 0,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip,
              tooltipBottom: '',
              hintField: null,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.forms.yes,
                },
                {
                  id: 0,
                  label: this.$root.staticText.forms.no,
                },
              ],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'sales',
              title: this.$root.staticText.lk.compForm3,
              typeField: 14,
              requiredField: 0,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip,
              tooltipBottom: '',
              isShort: true,
              dropzone: true,
              isFileAdd: false,
              hintField: null,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.forms.yes,
                },
                {
                  id: 0,
                  label: this.$root.staticText.forms.no,
                },
              ],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'tech',
              title: this.$root.staticText.lk.compForm4,
              typeField: 14,
              requiredField: 0,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip,
              tooltipBottom: '',
              isShort: true,
              dropzone: true,
              isFileAdd: false,
              hintField: null,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.forms.yes,
                },
                {
                  id: 0,
                  label: this.$root.staticText.forms.no,
                },
              ],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'business',
              title: this.$root.staticText.lk.compForm5,
              typeField: 14,
              requiredField: 0,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip2,
              tooltipBottom: this.$root.staticText.lk.compTooltipBottom,
              hintField: null,
              dropzone: true,
              isFileAdd: false,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.forms.yes,
                },
                {
                  id: 0,
                  label: this.$root.staticText.forms.no,
                },
              ],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'expertise',
              title: this.$root.staticText.lk.compForm7,
              typeField: 14,
              requiredField: 1,
              description: null,
              tooltip: this.$root.staticText.lk.compTooltip,
              tooltipBottom: '',
              hintField: null,
              isFull: true,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.lk.compFormLabel7,
                },
                {
                  id: 0,
                  label: this.$root.staticText.lk.compFormLabel72,
                },
              ],
            },
          },
        ],
      },
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    VueRecaptcha,
    'select-custom-cmp': selectCustom,
  },
  methods: {
    ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),

    onCapchaRegister(recaptchaToken) {
      this.recaptchaToken = recaptchaToken
      if (this.isValid) {
        this.sendForm()
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    errorCaptcha() {
      console.log('errorCaptcha')
    },

    fileAdded(item, i) {
      setTimeout(() => {
        let dropzone = this.$refs['dropzone' + item.id][0]
        item.isFileAdd = dropzone && dropzone.getAcceptedFiles().length > 0
        this.cmpForm[i].error = false
      }, 100)
    },

    changePersonalDataFrom() {
      this.infoForm.isPersonalData = !this.infoForm.isPersonalData
      this.infoForm.errorPersonalData = !this.infoForm.isPersonalData
    },

    validate() {
      let is_valid = true
      for (let i = 0; i < this.cmpForm.length; i++) {
        this.cmpForm[i].error = false
        if (
          this.cmpForm[i].pattern !== '' &&
          (!this.cmpForm[i].requiredField ? this.cmpForm[i].value !== null && this.cmpForm[i].value !== '' : true)
        ) {
          this.cmpForm[i].valid = true
          if (!this.cmpForm[i].pattern.test(this.cmpForm[i].value.trimEnd())) {
            this.cmpForm[i].error = true
            this.cmpForm[i].valid = false
            is_valid = false
          }
        }

        let dropzoneItem = this.$refs['dropzone' + this.cmpForm[i].id]
        if (this.cmpForm[i].dropzone && dropzoneItem && dropzoneItem[0] && dropzoneItem[0].getAcceptedFiles().length === 0) {
          this.cmpForm[i].error = true
          this.cmpForm[i].valid = false
          is_valid = false
        }

        if (this.cmpForm[i].requiredField && this.cmpForm[i].value === '') {
          this.cmpForm[i].error = true
          this.cmpForm[i].valid = false
          is_valid = false
        }

        if (this.cmpForm[i].type === 'select' && this.cmpForm[i].requiredField && this.cmpForm[i].value.length === 0) {
          this.cmpForm[i].error = true
          this.cmpForm[i].valid = false
          is_valid = false
        }
      }
      // проверка галочки
      if (!this.infoForm.isPersonalData) {
        this.infoForm.errorPersonalData = true
        is_valid = false
      }

      this.isValid = is_valid
    },
    submitForm() {
      this.validate()

      if (!this.isValid) return

      const isProd = process.env.NODE_ENV === 'production'

      if (isProd) {
        this.$refs.recaptcha.execute()
        return
      }

      this.sendForm()
    },
    sendForm() {
      this.infoForm.disabledForm = true
      let fd = new FormData()
      fd.append('recaptchaToken', this.recaptchaToken)
      if (this.props.ownerId) {
        fd.append('ownerId', this.props.ownerId)
      }
      for (let i = 0; i < this.cmpForm.length; i++) {
        if (this.cmpForm[i].type === 'radio' && this.cmpForm[i].dropzone) {
          fd.append(this.cmpForm[i].id, this.cmpForm[i].value.toString().trimEnd())
          if (this.$refs['dropzone' + this.cmpForm[i].id] && this.$refs['dropzone' + this.cmpForm[i].id][0]) {
            for (let j = 0; j < this.$refs['dropzone' + this.cmpForm[i].id][0].getAcceptedFiles().length; j++) {
              fd.append(this.cmpForm[i].id + 'Dropzone[]', this.$refs['dropzone' + this.cmpForm[i].id][0].getAcceptedFiles()[j])
            }
          }
        } else if (this.cmpForm[i].type === 'select') {
          for (let k = 0; k < this.$refs[`select${this.cmpForm[i].id}`][0].value.length; k++) {
            fd.append(this.cmpForm[i].id, this.$refs[`select${this.cmpForm[i].id}`][0].value[k].id)
          }
        } else if (this.cmpForm[i].value !== null) {
          fd.append(this.cmpForm[i].id, this.cmpForm[i].value.toString().trimEnd())
        }
      }
      if (this.vendorId) {
        fd.append('vendorId', this.vendorId)
      }

      const url = process.env.NODE_ENV === 'production' ? this.infoForm.action : `lk/competenciesFormSubmit.json`

      const method = process.env.NODE_ENV === 'production' ? 'post' : 'get'

      Vue.http[method](url, fd)
        .then(response => response.json())
        .then(data => {
          this.infoForm.disabledForm = false
          if (data.success) {
            this.modalClose()
            this.modalType_successOpen({
              title: this.$root.staticText.lk.compSuccessTitle,
              text: this.$root.staticText.lk.compSuccessText,
              class: '_small',
            })
            // this.$parent.$parent.$children[3].$children[0].updateData()
          } else {
            this.openErrorModal(data)
          }
        })
        .catch(data => {
          this.infoForm.disabledForm = false
          this.openErrorModal(data)
        })
    },
    openErrorModal(data) {
      let text = this.$root.staticText.modal.errorText
      if (data.errors) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }
      this.modalClose()
      this.modalType_errorOpen({
        title: this.$root.staticText.modal.errorTitle,
        text: text,
        class: '_small',
      })
    },
    focusForm(i) {
      this.cmpForm[i].error = false
    },
    changeRadio(index, event) {
      this.cmpForm[index].value = event.target.value
    },
    changeRadioId(index, value) {
      this.cmpForm[index].value = value
    },
    setCmpForm(data) {
      this.cmpForm.forEach((item, index) => {
        if (data) {
          let elem = data.find(el => el.id === item.id)
          if (elem && item.type === 'radio') {
            item.value = elem.value
            this.changeRadioId(index, elem.value.toString())

            if (elem.value.toString() === '1') {
              this.$refs[`radio${item.id}`][0].checked = true
              if (elem.files) {
                setTimeout(() => {
                  elem.files.forEach(file => {
                    this.$refs['dropzone' + item.id][0].addFile(file)
                  })
                }, 10)
              }
            } else {
              this.$refs[`radio${item.id}`][1].checked = true
            }
          } else if (elem && item.type === 'select') {
            setTimeout(() => {
              item.value = elem.value
              this.$refs[`select${item.id}`][0].listCreated()
              this.$refs[`select${item.id}`][0].valueCreated()
            }, 10)
          } else if (elem) {
            item.value = elem.value
          }
        } else {
          if (item.type === 'select') {
            setTimeout(() => {
              this.$refs[`select${item.id}`][0].listCreated()
              this.$refs[`select${item.id}`][0].valueCreated()
            }, 10)
          } else if (item.type === 'radio' && item.id !== 'expertise') {
            setTimeout(() => {
              this.$refs[`radio${item.id}`][1].checked = true
            }, 10)
          }
        }
      })
    },
  },
  created() {
    this.formInfo.fields.forEach(item => {
      if (!item.content.value) {
        item.content.value = item.content.defaultValue ? item.content.defaultValue : ''
      }
      item.content.error = false
      item.content.valid = false

      switch (item.content.typeField) {
        case 1:
          item.content.type = 'text'
          item.content.pattern = /\S{2,}/i
          break
        case 13:
          item.content.type = 'text'
          item.content.pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i
          break
        case 2:
          item.content.type = 'textarea'
          item.content.pattern = /\S{2,}/i
          break
        case 3:
          item.content.type = 'text'
          item.content.pattern = /^(\d)+$/
          break
        case 11:
          item.content.type = 'phone'
          item.content.pattern = ''
          break
        case 4:
          item.content.type = 'text'
          item.content.pattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i
          break
        case 5:
          item.content.type = 'date-picker'
          item.content.pattern = /\S{2,}/i
          break
        case 6:
          item.content.type = 'dropzone'
          item.content.pattern = ''
          this.dropzoneOptions.acceptedFiles = item.content.extensions
            .split(',')
            .map(item => '.' + item)
            .join(',')
          break
        case 7:
        case 8:
          item.content.type = 'select'
          item.content.pattern = ''
          item.content.value = []
          break
        case 9:
          item.content.type = 'checkbox'
          item.content.pattern = ''
          item.content.list.forEach(item => (item.checked = false))
          break
        case 14:
          item.content.type = 'radio'
          item.content.pattern = ''
          item.content.value = ''
          // item.content.value = item.content.list[0].id;
          break
        case 10:
          item.content.type = 'images'
          item.content.pattern = ''
          item.content.list.forEach(item => (item.checked = false))
          break
        case 12:
          item.content.type = 'hidden'
          item.content.pattern = ''
          break
        default:
          item.content.type = 'text'
          item.content.pattern = /\S{2,}/i
          break
      }
    })
    // Object.assign нужен для реактивности
    this.cmpForm = this.formInfo.fields.map(item => Object.assign({}, item.content))

    // если это модалка редактирования компатенций
    if (this.props.isEdit) {
      let url = process.env.NODE_ENV !== 'production' ? 'lk/editCompetencies.json' : 'lk/editCompetencies'

      Vue.http
        .get(url, { params: { id: this.props.ownerId } })
        .then(response => response.json())
        .then(data => {
          this.setCmpForm(data.data)
          this.vendorId = data.data[8]
        })
      //модалка создания компетенции
    } else {
      this.setCmpForm()
      this.vendorId = this.props.vendorId
    }
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/competencies.vue